import { useWindowSize } from 'application/helpers'
import { getCurrentResolutionBreakPoint } from 'application/utils/utilityFunctions'
import React from 'react'
import { Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import * as S from './proposalElements'

interface ICardEntryProps {
  title?: string | JSX.Element
  value?: string
  id: string
  boldText?: boolean
  boldValue?: boolean
  valueColour?: string
}

const CardEntry = ({
  title,
  value,
  id,
  boldText,
  boldValue,
  valueColour,
}: ICardEntryProps) => {
  const isDownloadingPdf = useSelector(
    (state: any) => state.downloadPdf.isDownloading
  )

  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  const [width] = useWindowSize()
  let isDesktop = width >= resolutionBreakpoint.nonDesktop

  return (
    <>
      {value !== '$0' && value !== null && isDesktop && (
        <Row>
          <S.CardText bold={boldText} id={id + '_title'}>
            {title}
          </S.CardText>
          <S.CardValue id={id + '_value'} bold={boldValue} colour={valueColour}>
            {value}
          </S.CardValue>
        </Row>
      )}
      {value !== '$0' && value !== null && !isDesktop && (
        <>
          <Row>
            <S.CardText bold={boldText} id={id + '_title'}>
              {title}
            </S.CardText>
          </Row>
          <Row>
            <S.CardValue
              id={id + '_value'}
              bold={boldValue}
              colour={valueColour}
            >
              {value}
            </S.CardValue>
          </Row>
        </>
      )}
    </>
  )
}

export default CardEntry
